import * as React from "react";
import Svg, { Path } from "react-native-svg";
const PaperOnlyIcon = ({ customColor, ...props }) => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path d="M17.0083 7.00833L12.9833 2.98333C12.675 2.675 12.25 2.5 11.8083 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V8.19167C17.5 7.75 17.325 7.325 17.0083 7.00833ZM5.83333 5.83333H11.6667V7.5H5.83333V5.83333ZM14.1667 14.1667H5.83333V12.5H14.1667V14.1667ZM14.1667 10.8333H5.83333V9.16667H14.1667V10.8333Z" fill={customColor ?? "black"} />
    </Svg>
);
export default PaperOnlyIcon;
